import { rank_apis } from './rank_apis';
import { match_apis } from './match_apis';
import { search_apis } from './search_apis';
import { user_apis } from './user_apis';
import { report_apis } from './report_apis';

export const apis = {
	...user_apis,
	...match_apis,
	...search_apis,
	...rank_apis,
	...report_apis,
};
